export const state = {
  userData: JSON.parse(localStorage.getItem('userData')) ? JSON.parse(localStorage.getItem('userData')) : null,
  cities: [],
  city_id: JSON.parse(localStorage.getItem('userData')) ? JSON.parse(localStorage.getItem('userData')).city_id : '',
}
